import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { MainAPI } from "../../../axios/api";
import { useAbortedEffect } from "../../../components/hooks";

import ModuleChartRadar from "../../../components/chart/radar";
import { convertToCanvas } from "../../../service/common";
import { com_downloadFileSingle } from "../../../service/downloadFile";
import { option_group, option_score } from "../../../service/option";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function ModulePopReportRadar({ popPreOption, closePrePop }) {
  const dispatch = useDispatch();
  const [apiData, setApiData] = useState(null);
  const [chartSetting, setChartSetting] = useState({
    data: [], // 資料
    options: {
      axis: {
        key: "", // 雷達類型 key
        domain: [], // 數值範圍
      },
      columns: [], // 對象
    },
  });

  useAbortedEffect(
    (signal) => {
      if (!popPreOption.data) return;

      dispatch(setProgress(true));

      let params = {
        id: popPreOption.data.id,
      };

      let promise;
      switch (popPreOption.data.qType) {
        case "type1":
          promise = MainAPI.getQuestionnaireData1Details({
            data: params,
            options: { signal },
          });
          break;
        case "type2":
          promise = MainAPI.getQuestionnaireData2Details({
            data: params,
            options: { signal },
          });
          break;
        case "type3":
          promise = MainAPI.getQuestionnaireData3Details({
            data: params,
            options: { signal },
          });
          break;
        default:
          promise = MainAPI.getQuestionnaireData1Details({
            data: params,
            options: { signal },
          });
      }

      promise.then((result) => {
        let { data, message } = result;

        if (data) {
          let temp = option_group[popPreOption.data.qType].map((item) => ({
            group: item.name,
            value: data.type_score[item.key] ?? 0,
          }));

          setApiData({
            raw: data,
            radar: temp,
          });
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [popPreOption]
  );

  useEffect(() => {
    if (!apiData) return;
    console.log(apiData);
    setChartSetting({
      data: apiData.radar,
      options: {
        axis: {
          key: "group",
          domain: [0, option_score[popPreOption.data.qType]],
        },
        columns: [
          {
            key: "value",
            name: apiData.raw.member_name
              ? apiData.raw.member_name
              : apiData.raw.member_email,
            color: "#8884d8",
          },
        ],
      },
    });
  }, [apiData]);

  const downloadImg = () => {
    dispatch(setProgress(true));

    convertToCanvas({ targetId: "chart_radar" }).then((result) => {
      com_downloadFileSingle({
        isBlob: true,
        fileName: `雷達圖_${chartSetting.options.columns[0].name}`,
        url: result.blob,
        finishAction: () => dispatch(setProgress(false)),
      });
    });
  };

  return (
    <>
      <div className="relative px-3">
        <div className="absolute top-0 right-0 mt-1 mr-4 z-1">
          <Button icon="pi pi-download" onClick={() => downloadImg()}></Button>
        </div>
        <div id="chart_radar" className="h-22rem bg-white">
          <ModuleChartRadar
            cData={chartSetting.data}
            cOptions={chartSetting.options}
          />
        </div>
        <div className="text-right mt-3">
          <Button
            className="p-button-secondary px-4"
            type="button"
            label="關閉"
            onClick={() => closePrePop({ type: "radar" })}
          />
        </div>
      </div>
    </>
  );
}
